import { Box } from "@mui/material";
import React from "react";
import { useRecordContext } from "react-admin";

type ActivityTypeFieldProps = {
  label?: string;
  size?: number;
};

const getActivityTypeFromMetaTag = (cmsActivityTypeMetaTag: string): string => {
  const activityTypeMap: Record<string, string> = {
    cognitive: "cognitive",
    physical: "physical",
    "social-and-communicative": "social",
    "mental-wellbeing": "wellbeing",
  };

  return activityTypeMap[cmsActivityTypeMetaTag] || "";
};

export const ActivityTypeField: React.FC<ActivityTypeFieldProps> = ({ size = 24 }) => {
  const record = useRecordContext();
  const activityType = record?.activityType;

  if (!activityType) {
    return null;
  }

  const iconType = getActivityTypeFromMetaTag(activityType);

  if (!iconType) {
    return null;
  }

  return (
    <Box
      component="img"
      src={`/images/${iconType}-icon.svg`}
      alt={`${iconType} activity`}
      width={size}
      height={size}
      sx={{ display: "inline-block", verticalAlign: "middle" }}
    />
  );
};
